import React, { useEffect } from 'react';
import { authReducer } from '../reducers';
import { SET_USER, SET_AUTHORIZED } from '../constants';
import AuthContext from '../contexts';

import { useCustomEventListener } from 'react-custom-events'

import {
  readFromLocalStorage,
  clearLocalStorage,
  setDefaultHeader,
  validateUser,
  unsetDefaultHeader
} from '../utils';

const initialAuthState = {
  user: null,
  isAuthorized: false
};

function AuthProvider(props) {
  const [state, dispatch] = React.useReducer(authReducer, initialAuthState);

  useCustomEventListener('log_out', () => {
    clearLocalStorage();
    unsetDefaultHeader();
    dispatch({ type: SET_USER, data: null });
  })

  useEffect(() => {
    const user = readFromLocalStorage();

    if (!user) {
      // window.location.href = '/log_in';
      dispatch({ type: SET_AUTHORIZED, data: true })
      
      return;
    }

    const isValid = validateUser(user);

    if (!isValid) {
      clearLocalStorage();
      dispatch({ type: SET_AUTHORIZED, data: true })
      // redirect
      return;
    }

    setDefaultHeader(user);
    dispatch({ type: SET_USER, data: user });
    dispatch({ type: SET_AUTHORIZED, data: true })
  }, []);

  return (
    <AuthContext.Provider value={[state, dispatch]} {...props} />
  );
}

export default AuthProvider;
